export class Location {
  coordinates: Point;
  range: number;
  address: string;
  constructor(){
    this.coordinates =  new Point();
  }
}
export class Point {
  elevation: number;
  lat: number;
  lon: number;
  time: string;
}
